import '../../styles/eventsTouch.css';
import '../../styles/eventsBoard.css';
// Module 19 (BL-380) - shared look for the Events screens.
import { BTN, BTN_ON, TILE, standardPillClass } from '../ui/platformStandard';
// Platform standard (Val, Oct 25 2026): Events uses the Communications button standard. Every filter, view and action pill is the shared
// 3D face (.ia-btn3d): navy at rest, turquoise when selected. One 32 px face with a 44 px box on touch screens (the shared rule).
// The export names stay so every Events caller (and its tests) keeps working.

export function pillClass(selected) {
    return standardPillClass(selected);
}

// One option inside a labelled filter row (FilterGroup). Same 3D pill as Communications' filters.
export function segmentClass(selected) {
    return standardPillClass(selected);
}

// A pill that does something (rather than filters): navy 3D, like "+ New message" in Communications.
export const ACTION_PILL_CLASS = `${BTN} inline-flex items-center gap-2`;

export const ACTION_PILL_QUIET_CLASS = `${BTN} inline-flex items-center gap-2`;

// Export: the same navy 3D pill (the glass look is retired by the platform standard).
export const GLASS_PILL_CLASS = `${BTN} inline-flex items-center gap-2`;
export const GLASS_PILL_STYLE = {};
export const SELECTED_PILL_CLASS = BTN_ON;

// Panels and tiles: the platform tile (raised surface, signature gradient on top, one depth language in light and dark).
export const TILE_CLASS = TILE;
export const PANEL_CLASS = 'bg-[var(--surface-raised)] border-[var(--surface-border)]';
export const INPUT_CLASS = 'w-full rounded-lg border px-3 py-2 min-h-[44px] lg:[@media(pointer:fine)]:min-h-0 outline-none focus:ring-2 focus:ring-brand-500 bg-[var(--surface-sunken)] border-[var(--surface-border)] text-[var(--ink)] placeholder-[var(--ink-muted)]';
